const appUrl = process.env.APP_URL
const apiUrl = process.env.API_URL

export default {
  appUrl,
  signupUrl: appUrl + '/signup',
  signinUrl: appUrl + '/signin',
  google: {
    analytics: {
      id: process.env.VUE_APP_GA_ID
    }
  },
  api: {
    url: apiUrl
  },
  sentry: {
    dsn: process.env.SENTRY_DSN
  }
}



// WEBPACK FOOTER //
// ./client/config/index.js